import React from 'react';

import PropTypes from 'prop-types';

import { useSelector, shallowEqual } from 'react-redux';

import { getAssignmentHashKey } from '@components/status-cell/helpers';
import StatusCell from '@components/status-cell';

import GridHeader from './grid-header';

import { GridContainer, Header, CellContainer, GridColumn } from './styled';

const Grid = props => {
  const { standardId } = props;

  /**
   * Store
   */
  const standards = useSelector(state => state.entitiesReducer.standards);
  const assignments = useSelector(state => state.entitiesReducer.assignments);
  const selectedAssignmentHashKeys = useSelector(state => state.UPFAssignReducer.selectedAssignmentHashKeys);
  const sortedStudentIds = useSelector(state => state.UPFAssignReducer.sortedStudentIds);
  const { currentFilter } = useSelector(state => state.UPFAssignReducer.accuracyProgressToggle, shallowEqual);

  /**
   * Local variables
   */
  const { childTopics: learningJourneyIds = [] } = standards[standardId] || {};

  return (
    <GridContainer>
      <Header>
        {learningJourneyIds.map(learningJourneyId => (
          <GridHeader
            key={learningJourneyId}
            learningJourneyId={learningJourneyId}
            sortedStudentIds={sortedStudentIds}
          />
        ))}
      </Header>
      <CellContainer>
        {learningJourneyIds.map(learningJourneyId => (
          <GridColumn key={learningJourneyId}>
            {sortedStudentIds.map(studentId => {
              const assignmentHashKey = getAssignmentHashKey(studentId, learningJourneyId);
              const assignment = assignments[assignmentHashKey];
              const isSelected = !!selectedAssignmentHashKeys[assignmentHashKey];

              return (
                <StatusCell
                  assignment={assignment}
                  assignmentHashKey={assignmentHashKey}
                  currentResultFilter={currentFilter}
                  isSelected={isSelected}
                  key={assignmentHashKey}
                  learningJourneyId={learningJourneyId}
                  studentId={studentId}
                />
              );
            })}
          </GridColumn>
        ))}
      </CellContainer>
    </GridContainer>
  );
};

Grid.propTypes = {
  standardId: PropTypes.number.isRequired
};

export default Grid;
